/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Provision_RentInputs */

const cs_settings_office_provision_rent = /** @type {(inputs: Settings_Office_Provision_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% u pronájmu`)
};

const en_settings_office_provision_rent = /** @type {(inputs: Settings_Office_Provision_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rent %`)
};

/**
* | output |
* | --- |
* | "Rent %" |
*
* @param {Settings_Office_Provision_RentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_provision_rent = /** @type {((inputs?: Settings_Office_Provision_RentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Provision_RentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_provision_rent(inputs)
	return cs_settings_office_provision_rent(inputs)
});